// eslint-disable-next-line import/prefer-default-export
export const indoorPoolTitleTagsMap: { [key: string]: string } = {
  1437: 'Westin Chicago Lombard: Indoor Pool & Spa Day Pass | ResortPass',
  1587: 'Toronto Athletic Club: Indoor Pool & Spa Day Pass | ResortPass',
  1631: 'The St. Regis Punta Mita Resort: Indoor Pool & Spa Day Pass | ResortPass',
  1949: 'The Ridge Hotel: Indoor Pool & Spa Day Pass | ResortPass',
  2107: 'The Porter Portland, Curio Collection by Hilton: Indoor Pool & Spa Day Pass | ResortPass',
  1297: 'The Plunge San Diego: Indoor Pool & Spa Day Pass | ResortPass',
  1494: 'Sybaris Pool Suites Frankfort: Indoor Pool & Spa Day Pass | ResortPass',
  1908: 'Sun Outdoors Sarasota: Indoor Pool & Spa Day Pass | ResortPass',
  1376: 'Staybridge Suites Florence - Cincinnati South: Indoor Pool & Spa Day Pass | ResortPass',
  2209: 'Sonesta Emeryville, San Francisco Bay Bridge: Indoor Pool & Spa Day Pass | ResortPass',
  1902: 'Sonesta Atlanta Airport South: Indoor Pool & Spa Day Pass | ResortPass',
  2301: 'Sheraton Grand Rapids Airport Hotel: Indoor Pool & Spa Day Pass | ResortPass',
  2179: 'Seattle Marriott Waterfront: Indoor Pool & Spa Day Pass | ResortPass',
  1238: 'Sanderling Resort: Indoor Pool & Spa Day Pass | ResortPass',
  1820: 'Royal Sonesta Boston: Indoor Pool & Spa Day Pass | ResortPass',
  1530: 'Pocono Palace Resort: Indoor Pool & Spa Day Pass | ResortPass',
  1726: 'Overleaf Lodge and Spa: Indoor Pool & Spa Day Pass | ResortPass',
  122: 'JW Marriott Chicago: Indoor Pool & Spa Day Pass | ResortPass',
  1012: 'Hotel Nikko San Francisco: Indoor Pool & Spa Day Pass | ResortPass',
  1390: 'Home2 Suites Troy: Indoor Pool & Spa Day Pass | ResortPass',
  1430: 'Hilton Garden Inn Denver Union Station: Indoor Pool & Spa Day Pass | ResortPass',
  1842: 'Hilton Chicago/Northbrook: Indoor Pool & Spa Day Pass | ResortPass',
  268: 'Gaylord Texan Resort: Indoor Pool & Spa Day Pass | ResortPass',
  1814: 'Gaylord National Resort & Convention Center: Indoor Pool & Spa Day Pass | ResortPass',
  2308: 'Four Seasons Hotel Chicago: Indoor Pool & Spa Day Pass | ResortPass',
  2081: 'Four Points by Sheraton Toronto Mississauga: Indoor Pool & Spa Day Pass | ResortPass',
  1295: 'Fairmont Spa Banff Springs: Indoor Pool & Spa Day Pass | ResortPass',
  1618: 'Embassy Suites by Hilton Seattle-Tacoma Airport: Indoor Pool & Spa Day Pass | ResortPass',
  1035: 'Embassy Suites by Hilton San Rafael Marin County: Indoor Pool & Spa Day Pass | ResortPass',
  1448: 'Embassy Suites by Hilton Seattle Downtown Pioneer Square: Indoor Pool & Spa Day Pass | ResortPass',
  1417: 'Embassy Suites by Hilton Napa Valley: Indoor Pool & Spa Day Pass | ResortPass',
  860: 'Embassy Suites by Hilton LAX Airport North: Indoor Pool & Spa Day Pass | ResortPass',
  1449: 'Denver Marriott West: Indoor Pool & Spa Day Pass | ResortPass',
  1529: 'Cove Haven Resort: Indoor Pool & Spa Day Pass | ResortPass',
  1109: 'Courtyard by Marriott Orlando Lake Buena Vista in the Marriott Village: Indoor Pool & Spa Day Pass | ResortPass',
  1467: 'Courtyard by Marriott Edina Bloomington: Indoor Pool & Spa Day Pass | ResortPass',
  1235: 'Cincinnati Marriott at RiverCenter: Indoor Pool & Spa Day Pass | ResortPass',
  2284: 'Bluebird Cady Hill Lodge: Indoor Pool & Spa Day Pass | ResortPass',
  1588: 'Adelaide Club: Indoor Pool & Spa Day Pass | ResortPass',
  2224: 'Sonesta Select Atlanta Cumberland Galleria: Indoor Pool & Spa Day Pass | ResortPass',
  2228: 'Sonesta Select Boston Foxborough Mansfield: Indoor Pool & Spa Day Pass | ResortPass',
  2084: 'The Kartrite Resort & Indoor Waterpark: Indoor Pool & Spa Day Pass | ResortPass',
  1582: 'Warner Center Marriott Woodland Hills: Indoor Pool & Spa Day Pass | ResortPass',
  900: 'Hyatt Lodge and Spa at Oak Brook Reserve: Indoor Pool & Spa Day Pass | ResortPass',
  2208: 'Sonesta Select Seattle Bellevue Redmond: Indoor Pool & Spa Day Pass | ResortPass',
  2221: 'The Stephen F Austin Royal Sonesta Hotel: Indoor Pool & Spa Day Pass | ResortPass',
  2289: 'Pine Mountain Ski & Golf Resort: Indoor Pool & Spa Day Pass | ResortPass',
  1299: 'Hyatt Place Chicago/Hoffman Estates: Indoor Pool & Spa Day Pass | ResortPass',
  2037: 'Timber Ridge Lodge & Waterpark: Indoor Pool & Spa Day Pass | ResortPass',
  1768: 'Atlanta Evergreen Lakeside Resort: Indoor Pool & Spa Day Pass | ResortPass',
  1635: 'The Westin San Francisco Airport: Indoor Pool & Spa Day Pass | ResortPass',
  511: 'Fairmont Sonoma Mission Inn & Spa: Indoor Pool & Spa Day Pass | ResortPass',
  2160: 'The Spa at Trump® & Fitness Club: Indoor Pool & Spa Day Pass | ResortPass',
  2288: 'The Four Seasons Island Resort: Indoor Pool & Spa Day Pass | ResortPass',
  2283: 'Talta Lodge, a Bluebird by Lark: Indoor Pool & Spa Day Pass | ResortPass',
  924: 'DoubleTree by Hilton Lansing: Indoor Pool & Spa Day Pass | ResortPass',
  1718: 'Aloft San Francisco Airport: Indoor Pool & Spa Day Pass | ResortPass',
  1827: "Boar's Head Resort: Indoor Pool & Spa Day Pass | ResortPass",
  1466: 'Irish Cottage Inn & Suites: Indoor Pool & Spa Day Pass | ResortPass',
  384: 'Grove Fitness Club and Spa: Indoor Pool & Spa Day Pass | ResortPass',
  2173: 'La Posada Lodge & Casitas: Indoor Pool & Spa Day Pass | ResortPass',
  1531: 'Paradise Stream Resort: Indoor Pool & Spa Day Pass | ResortPass',
  412: 'Hilton Americas-Houston: Indoor Pool & Spa Day Pass | ResortPass',
};
